import { useParams } from "react-router-dom";
import { GiBookmark } from "react-icons/gi";


import { actions, hasPermission } from "../../services/security";

import Card from "./../../Components/ui/card";
import Header from "./../../Components/ui/header";
import DiccionarioForm from "../../Components/diccionario/Diccionario-form";

const DiccionarioDetailPage = () => {
  const { id } = useParams();


  const action =
    id === "nuevo"
      ? "Crear"
      : hasPermission(actions.DiccionarioVer)
      ? "Editar"
      : "Ver";

  const title = `${action} Diccionario`;
  const icon = <GiBookmark />;
  const breadcrumb = [
    { title: "Diccionario", url: "/diccionario" },
    { title: action, url: `/diccionario/${id}` },
  ];

  return (
    <Card>
      <Header title={title} icon={icon} breadcrumb={breadcrumb} />
      <DiccionarioForm id={id} />
    </Card>
  );
};

export default DiccionarioDetailPage;
